<template>
  <v-container
    id="groupSummary"
  >
    <div class="oe-summary-title">
      <v-btn
        class="mx-2"
        fab
        dark
        x-small
        :color="approvals.color"
        @click="displayOESummary = !displayOESummary"
      >
        <v-icon
          v-show="!displayOESummary"
          dark
        >
          mdi-arrow-expand-vertical
        </v-icon>
        <v-icon
          v-show="displayOESummary"
          dark
        >
          mdi-arrow-expand-horizontal
        </v-icon>
      </v-btn>
      Open Enrollment
    </div>
    <v-fab-transition>
      <div
        v-show="displayOESummary && openEnrollment"
        class="oe-summary-subsection"
      >
        <group-summary-detail-fields
          :open-enrollment="openEnrollment"
        />
      </div>
    </v-fab-transition>
    <v-progress-linear
      v-show="loading"
      indeterminate
      color="amber"
    />
    <v-alert
      v-if="!loading && !group"
      type="info"
    >
      No group details found
    </v-alert>
    <div v-if="!loading && group">
      <div class="oe-summary-title page-break-before">
        <v-btn
          class="mx-2"
          fab
          dark
          x-small
          :color="approvals.color"
          @click="displayGroupSummarySection = !displayGroupSummarySection"
        >
          <v-icon
            v-show="!displayGroupSummarySection"
            dark
          >
            mdi-arrow-expand-vertical
          </v-icon>
          <v-icon
            v-show="displayGroupSummarySection"
            dark
          >
            mdi-arrow-expand-horizontal
          </v-icon>
        </v-btn>
        Group Summary
      </div>
      <v-fab-transition>
        <div
          v-show="displayGroupSummarySection"
          class="oe-summary-subsection"
        >
          <group-summary-fields
            :group="group"
          />
        </div>
      </v-fab-transition>
    </div>
    <v-alert
      v-if="!loading && (!roles || !roles.length)"
      type="info"
    >
      No team members associated with this group
    </v-alert>
    <div v-if="!loading && roles && roles.length">
      <div class="oe-summary-title page-break-before">
        <v-btn
          class="mx-2"
          fab
          dark
          x-small
          :color="approvals.color"
          @click="displayTeamSection = !displayTeamSection"
        >
          <v-icon
            v-show="!displayTeamSection"
            dark
          >
            mdi-arrow-expand-vertical
          </v-icon>
          <v-icon
            v-show="displayTeamSection"
            dark
          >
            mdi-arrow-expand-horizontal
          </v-icon>
        </v-btn>
        Team
      </div>
      <group-summary-team-fields
        v-show="displayTeamSection"
        :roles="roles"
      />
      <v-fab-transition>
        <approval
          v-show="displayOESummary || displayGroupSummarySection || displayTeamSection"
          :approvals="approvals"
          :allow-change="!print"
          @approval:changed="$emit('approval:changed')"
        />
      </v-fab-transition>
    </div>
    <base-material-snackbar
      v-model="displayError"
      type="error"
      v-bind="{
        top: true,
        right: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
  </v-container>
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'
  import Approvals from '@/services/troody/Approvals'

  export default {
    name: 'GroupSummary',

    components: {
      Approval: () => import('./Approval'),
      GroupSummaryDetailFields: () => import('./GroupSummaryDetailFields'),
      GroupSummaryFields: () => import('./GroupSummaryFields'),
      GroupSummaryTeamFields: () => import('./GroupSummaryTeamFields'),
    },

    props: {
      expanded: {
        type: Boolean,
        default: false,
      },
      details: {
        type: Object,
        default: null,
      },
      groupId: {
        type: [Number, String],
        default: null,
      },
      print: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      displayOESummary: true,
      displayGroupSummarySection: true,
      displayTeamSection: true,

      loadingGroup: false,
      loadingRoles: false,

      errorMessage: null,
      displayError: false,
      formErrors: {},

      group: null,
      roles: null,

      groupResource: new TroodyApi('group/'),
      groupRoleResource: new TroodyApi('groupRole/'),
      approvals: null,
    }),

    computed: {
      openEnrollment () {
        return (this.details || {})
      },

      loading () {
        return (this.loadingGroup || this.loadingRoles)
      },
    },

    watch: {
      groupId (val) {
        this.initialize()
      },

      expanded (val) {
        this.displayOESummary = val
        this.displayGroupSummarySection = val
        this.displayTeamSection = val
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.formErrors = {}
        this.loadSummary()
        this.approvals = new Approvals(this.openEnrollment.id, Approvals.sections.openEnrollments.id)

        this.displayOESummary = this.expanded
        this.displayGroupSummarySection = this.expanded
        this.displayTeamSection = this.expanded
      },

      loadSummary () {
        this.loadRoles()
        this.loadGroup()
      },

      loadRoles () {
        this.loadingRoles = true
        this.groupRoleResource.query({ groupId: this.groupId })
          .then(data => {
            this.loadingRoles = false
            this.roles = data
          })
          .catch((error) => {
            this.loadingRoles = false
            this.roles = null
            this.showError(error, 'Failed to load group roles!')
          })
      },

      loadGroup () {
        this.loadingGroup = true
        this.groupResource.get(this.groupId)
          .then(data => {
            this.loadingGroup = false
            this.group = data
          })
          .catch((error) => {
            this.loadingGroup = false
            this.group = null
            this.showError(error, 'Failed to load group details!')
          })
      },

      showError (error, msg) {
        console.log(error)
        this.errorMessage = (error || msg)
        this.displayError = true
      },
    },
  }
</script>

<style lang="sass">
  .team-member
    border-width: 3px
    border-style: solid
    border-color: rgba(0, 255, 0, 0.1) !important
    border-radius: 10px !important
    margin: 4px !important
</style>
